import { render } from "./theme-color.vue?vue&type=template&id=42cc7f17&scoped=true&ts=true"
import script from "./theme-color.vue?vue&type=script&lang=ts"
export * from "./theme-color.vue?vue&type=script&lang=ts"

import "./theme-color.vue?vue&type=style&index=0&id=42cc7f17&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42cc7f17"]])

export default __exports__